/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import CurrencyIcon from '../CurrencyIcon';

const RadioItem = ({
  name,
  onChange,
  checked,
  coin = null,
  label,
  amount = null,
  icon = null,
  subtitle = null,
  image = null,
  className = '',
  marginSpacing = 'my-3',
  paddingSpacing = 'px-3 py-3',
  style = null,
  disabled = false,
  backgroundColor = 'bg-light',
}) => (
  <div
    role="presentation"
    tabIndex={-1}
    onClick={!disabled ? onChange : () => {}}
    className={`cursor-pointer d-flex align-items-center ${backgroundColor} ${paddingSpacing} rounded-extra radio-item ${
      checked ? 'radio-item--checked border-primary' : ''
    }
       ${disabled ? 'radio-item--disabled' : ''} ${marginSpacing} ${className}`}
    style={{ ...style }}>
    <div className="form-check d-flex p-0 align-items-center flex-fill">
      {coin && <CurrencyIcon currencyCode={coin} className="m-0 d-flex" />}
      {icon && <i className={`icon icon-${icon} text-f4`} />}
      {image && (
        <div style={{ width: '2rem' }}>
          <img src={image} alt="Logo" className="me-2" />
        </div>
      )}
      <div className="d-flex flex-column mx-2">
        <b className="text-f5 text-dark">{label}</b>
        {amount && coin && <p className="text-f6 text-shadow">{`${amount} ${coin}`}</p>}
        {subtitle && <p className="text-f6 text-shadow">{`${subtitle}`}</p>}
      </div>
      <input
        className="form-check-input ms-auto d-none"
        type="radio"
        name={name}
        checked={checked}
        disabled={disabled}
      />
    </div>
    <div className="circle d-flex justify-content-center align-items-center">
      <span />
    </div>
  </div>
);

export default RadioItem;

RadioItem.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  coin: PropTypes.string,
  amount: PropTypes.string,
  icon: PropTypes.string,
  image: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  backgroundColor: PropTypes.string,
  marginSpacing: PropTypes.string,
  paddingSpacing: PropTypes.string,
};
